import _ from 'lodash';

const __bucketName = 'kv3';

let _kioskStandAlone = false;
let _parent = {window: {}};
try {
  if(parent.document) {
    _parent = parent;
  }
}
catch (e) {
  _parent = {window: {}};
}
try {
  _kioskStandAlone = _parent && _parent.window.app && _parent.window.app.db;
} catch (e) {
  _kioskStandAlone = false;
}
let _tabletMode = false;
let _showroomMode = false;
let _timeoutDisabled = false;
let _subdomain = 'demo';
let _isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1; //&& ua.indexOf("mobile");
let _internetExplorer = (window.navigator.userAgent.indexOf('MSIE ') > 0)
  || (!!window.MSInputMethodContext && !!document.documentMode) || (window.navigator.userAgent.indexOf('Trident/') > 0);
let _edge = (window.navigator.userAgent.indexOf('Edge') > 0);
let _firefox = (window.navigator.userAgent.indexOf('Firefox') > 0);
let _isIphone = (navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i));

if(_kioskStandAlone) {
  _parent.window.app.db.tables.config.getConfigs(configs => {
    let _kioskConfigs = {};
    _.each(configs, c => {
      _kioskConfigs[c.key] = c.value;
    });
    _tabletMode = _kioskConfigs['tablet-mode'];
    _showroomMode = _kioskConfigs['qt-showroom-mode'];
    _timeoutDisabled = _kioskConfigs['qt-timeout-disabled'];
    _subdomain = _kioskConfigs['subdomain'];
  });
}

window.addEventListener("message", function(event) {
  if (event.data.action === "updateQuoteFromIframe") {
    document.backFromIframe && document.backFromIframe();
    if (_.includes(window.location.href, "summary")) {
      document.setStoneFromIframeSummaryPage && document.setStoneFromIframeSummaryPage(event.data.data);
    } else if (_.includes(window.location.href, "stones")) {
      document.setStoneFromIframeStonesPage && document.setStoneFromIframeStonesPage(event.data.data);
    } else {
      document.setStoneFromIframe && document.setStoneFromIframe(event.data.data);
    }
  } else if (event.data.action === "reloadIframe") {
    document.reloadIframe && document.reloadIframe();
  } else if (event.data.action === "iframeLoaded") {
    document.reloadIframeStyles && document.reloadIframeStyles();
  } else if (event.data.action === "smallIframeLoaded") {
    document.removeLoadingMessage && document.removeLoadingMessage();
  } else if (event.data.action === 'saveIframeData') {
    document.setIframeState && document.setIframeState(event.data.data);
  } else if (event.data.action === 'scrollToTop') {
    document.body.scrollTop = 0;
  }
});

module.exports = {
  AmazonS3: {
    bucketName: __bucketName,
    root: "https://s3.amazonaws.com/" + __bucketName + "/"
  },
  appRootNode: '.main-wrapper',
  layerSize: function () {
    return "1620x1080";
  },

  /**
   * Returns a hardcoded feature description, this will be removed later
   * @param featureName
   */
  featureDescription: function (featureName) {
    switch ((featureName || '').toLowerCase()) {
      case 'material':
        return "How many square feet of material do you need for your project? If you need help calculating, press the square foot calculator button.";
      case "room":
        return "Please select the room in which you would like new countertops.";
      case "edge profile":
        return "The edge profile of the countertop is a small detail among many in the kitchen. " +
          "The shape of your countertop's edge can have a huge effect on function, impacting everything from cleaning to safety.";
      case "cutouts":
        return "Select the Cutouts you will need for your new countertops.";
      case "faucets":
      case "faucet":
        return "Do you need a faucet for your countertop project? If so, select the faucet that you would like to use for your countertops.";
      case "sinks":
      case "sink":
        return "Do you need a sink for your countertop project? If so, select the sink that you would like to use for your countertops.";
      case "counter top removal":
      case "counter top disposal":
        return "Professional removal and disposal of your existing countertop material." +
                "<br /> Please choose the counter top material you would like professionally disposed of.";
      case "radius":
        return "Radius corners refer to the degree of “roundness” the countertop corners will have “Soft” corners are " +
          "the corners that are exposed to traffic areas or where people walk.";
      case "plumbing":
        return "If you would like the plumbing work done by our team please select an option.";
      case "backsplash":
        return "Select a Backsplash option for your job.";
      case "sealer":
        return "Natural Stone requires some special considerations, but simple care and maintenance will keep your Natural Stone Countertops looking beautiful.";
      case "hourly labor":
        return "Hourly labor may be charged for work that needs to be done that may not be part of a standard installation or fabrication job.";
      case "trip charge":
        return "For service outside of our normal service range we may charge a trip charge to compensate for time and fuel.";
      case "milling down":
        return "Does your job require milling down of materials?  If so please enter the square footage below.";
      case "template":
        return "Please choose a template option below.";
      case "15 year sealer":
        return "Would you like a 15 year sealer applied to your stone?";
      case "10 year sealer":
        return "Would you like a 10 year sealer applied to your stone?";
      case "finishes":
        return "Some stones come with the option to add a custom finish.  Select a custom finish below.  (may not be available on certain stones)";
      case "flat metal support brackets":
        return "Select the number of brackets needed below.";
      case "bump out":
        return "Select the number of bump outs below.";
      case "inside corner":
        return "Select the number of inside corners below";
      case "45 degree inside corner":
        return "Select the number of 45 degree inside corners below.";
      case "arch":
        return "Select the number of arches below.";
      case "cooktop type":
        return "Please select type of stove so we may determine what type of cutout is required";
      case "sink type":
        return "Please select type of sink so we may determine what type of cutouts are required";
      case 'stove type':
        return 'Please select from the following options a Stove Type cutout for your counter top project';
      case 'protection plan':
        return 'Please select a Protection Plan from the following options.';
      default:
        return  'Please select from the following options';
    }
  },

  kioskStandAlone: _kioskStandAlone,
  kvConfig: document.kvConfig,
  isKiosk: document.kvConfig.kioskMode,
  isShowroomMode: () => { return _showroomMode; },
  isTimeoutDisabled: () => { return _timeoutDisabled; },
  isTabletMode: () => { return _tabletMode; },
  getSubdomain: () => { return _subdomain; },
  isInterentExplorer: () => { return _internetExplorer; },
  isEdge: () => { return _edge; },
  isAndroid: () => { return _isAndroid; },
  isFirefox: () => { return _firefox; },
  isIphone: () =>  _isIphone,
  parent: _parent
};






// WEBPACK FOOTER //
// ./src/config.js